import { compare, drop, dropLast, dropNulls, ensureArray, equal, filterAsync, findMandatory, first, groupBy, headAndTail, isSubset, last, moveItem, removeItemAtIndex, repeat, replaceElement, secondLast, startsWith, tail, take, toMap, unique, uniqueBy, } from "./arrays";
import { mapOf, toObject } from "./maps";
import { promiseOf, truthPoller } from "./promises";
import { basename, camelcaseToSentenceCase, camelize, dirname, extractTerms, isUndefinedOrNullOrEmptyString, mask, paragraphs, splitAtFirst } from "./string";
import { getQueryParams } from "./urls";
import { bestGuessAtMessageForUser, ErrorWithContext, mergeContext, mergeErrorContext, prependToMessage } from "./errors";
import { Selectable } from "./selections";
import { containsObject, dropKeys, dropKeysRecursive, keysAndValues, mapKeys, mapValues, merge, orderKeys, pick, sameJson, set, typeAwareEqual, walkTo, } from "./objects";
import { TextBlockParser } from "./TextBlockParser";
import { dates } from "./dates";
import { random } from "./random";
import { Debouncer } from "./Debouncer";
import { Counter } from "./Counter";
import { Stack } from "./Stack";
export const arrays = {
    secondLast,
    isSubset,
    startsWith,
    toMap,
    moveItem,
    unique,
    uniqueBy,
    groupBy,
    equal,
    removeItemAtIndex,
    ensureArray,
    filterAsync,
    repeat,
    take,
    drop,
    replaceElement,
    headAndTail,
    dropLast,
    last,
    first,
    tail,
    dropNulls,
    findMandatory,
    compare,
};
export const maps = {
    mapOf,
    toObject
};
export const promises = {
    promiseOf, truthPoller
};
export const urls = {
    getQueryParams
};
export const errors = {
    mergeContext,
    mergeErrorContext,
    bestGuessAtMessageForUser,
    ErrorWithContext,
    prependToMessage
};
const strings = {
    isUndefinedOrNullOrEmptyString,
    camelize,
    extractTerms,
    paragraphs,
    splitAtFirst,
    basename,
    dirname,
    camelcaseToSentenceCase,
    mask
};
export const objects = {
    pick,
    dropKeys,
    dropKeysRecursive,
    walkTo,
    mapKeys,
    sameJson,
    merge,
    typeAwareEqual,
    containsObject,
    set,
    orderKeys,
    keysAndValues,
    mapValues,
};
export function idLabelSelectedAndValue(id, label, selected, value) {
    return { id, label, selected, value };
}
export function idLabelAndValue(id, label, value) {
    return { id, label, value };
}
export function idLabelAndType(id, label, type) {
    return { id, label, type };
}
export function idAndLabel(id, label) {
    return { id, label };
}
export function idNameAndType(id, name, type) {
    return { id, name, type };
}
export function nameAndValue(name, value) {
    return { name, value };
}
export function nameValueAndType(name, value, type) {
    return { name, value, type };
}
export function idAndValue(id, value) {
    return { id, value };
}
export const always = () => true;
export const never = () => false;
export function idAndName(id, name) {
    return { id, name };
}
export const noopVoidCallback = () => {
};
export function mandatory(value, absenceErrorString) {
    if (value === null || value === undefined) {
        throw new Error(absenceErrorString);
    }
    return value;
}
export function hasValue(value) {
    return !(value === null || value === undefined);
}
export { ErrorWithContext, Selectable, strings, extractTerms, camelize, TextBlockParser, dates, random, Debouncer, Counter, Stack };
export { numbers } from './numbers';
export { partial1, partial2 } from './partial';
export { justErrorMessage, } from './errors';
export function identity(t) {
    return t;
}
export { toTypedError, toClientError, toBug, clientErrorCode, clientError, errorMessageAndCode, errorCode, } from './errors';
export { correlation } from './correlation';
